(async function () {
  const Layer = await waitForLayer();
  const { defineApp, register } = Layer.api.components;
  const shopify_ajax_privacy_api = Layer.api.privacy;

  register(
    "u-privacy-capture-app",
    defineApp({
      name: "UPrivacyCaptureApp",
      props: {
        "show-privacy-widget": {
          type: "boolean",
          default: false,
          reflect: true,
        },
        "show-ccpa-widget": {
          type: "boolean",
          default: false,
          reflect: true,
        },
      },
      attrs: {},
      setup(props, { expose, vue_lib }) {
        const { reactive, computed, ref } = vue_lib;
        const explicit_selections = reactive({
          analytics: true,
          preferences: true,
          marketing: true
        })

        const privacy_state = ref(null);
        const must_show_privacy_widget = computed(() => {
          if (!privacy_state) return false;
          return privacy_state.is_banner_required === true;
        });
        const must_show_ccpa_widget = computed(() => {
          if (!privacy_state) return false;
          return privacy_state.is_cpa_required === true;
        });
        const has_custom_selections = computed(() => {
          let flag = false;
          for (let i in explicit_selections) {
            if (!explicit_selections[i]) {
              flag = true;
              break;
            }
          }
          return flag;
        })

        const store = {
          explicit_selections,
          has_custom_selections,
          get privacy_state() {
            return privacy_state;
          },
          handleChecked({ target, detail }) {
            explicit_selections[target.getAttribute("name")] = detail;
          },
          state: reactive({
            sync_loading: false,
            sync_errored: false,
            action_loading: false,
            action_errored: false,
          }),
          get must_show_privacy_widget() {
            return must_show_privacy_widget.value;
          },
          get show_privacy_widget() {
            return props["show-privacy-widget"];
          },
          get must_show_ccpa_widget() {
            return must_show_ccpa_widget.value;
          },
          get show_ccpa_widget() {
            return props["show-ccpa-widget"];
          },
          async sync() {
            try {
              store.state.sync_loading = true;
              const test = await shopify_ajax_privacy_api.sync();
              return (privacy_state.value =
                await shopify_ajax_privacy_api.sync());
            } catch (error) {
              store.state.sync_errored = true;
            } finally {
              store.state.sync_loading = false;
            }
          },
          async update(privacy_state_update) {
            try {
              store.state.action_loading = true;
              await shopify_ajax_privacy_api.update(privacy_state_update);
              return await store.sync();
            } catch (error) {
              store.state.action_errored = true;
            } finally {
              store.state.action_loading = false;
            }
          },
          async acceptAllCookies() {
            props["show-privacy-widget"] = false;
            return store.update({
              marketing: true,
              analytics: true,
              preferences: true,
            });
          },
          async rejectAllCookies() {
            props["show-privacy-widget"] = false;
            return store.update({
              marketing: false,
              analytics: false,
              preferences: false,
            });
          },
          async acceptCCPA() {
            return store.update({
              sale_of_data: true,
            });
          },
          async rejectCCPA() {
            return store.update({
              sale_of_data: false,
            });
          },
        };

        window.t = store;

        expose("sync", store.sync.bind(store));
        expose("update", store.update.bind(store));

        store.sync();

        return store;
      },
    })
  );
})();
